import { type ReactNode, useEffect, useState } from "react";

import { preparePlatformAuth } from "./auth";

export function PlatformAuthBootstrap({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    void preparePlatformAuth().then(setReady);
  }, []);

  if (!ready) {
    return (
      <main
        aria-label="Loading"
        style={{ display: "grid", minHeight: "100vh", placeItems: "center" }}
      >
        Loading…
      </main>
    );
  }

  return children;
}
